// extracted by mini-css-extract-plugin
export default {"wrapper":"Picture_wrapper__Ph8pq","socialMedia":"Picture_socialMedia__klo76"};